import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

function NewsCard({ headline, story, date, id }) {
  return (
    <Box>
      <h2>{headline}</h2>
      <Story>
        <p>{story}</p>
        <span>{date}</span>
      </Story>
      <Link>
        <button>Read More</button>
      </Link>
    </Box>
  );
}

export default NewsCard;

const Box = styled.div`
  height: 105%;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  box-shadow: rgb(0 0 0 / 12%) 0px 8px 24px;
  border-radius: 10px;

  h2 {
    padding-top: 30px;
    font-size: 28px;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
  }

  button {
    width: 120px;
    height: 50px;
    background-color: transparent;
    border: 2px solid var(--primary);
    margin: 10px 0;
    outline: none;
    font-weight: 600;
    text-transform: uppercase;
    box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1),
      inset 2px 2px 5px rgba(0, 0, 0, 0.1);
    color: var(--primary);
    border-radius: 10px;

    :hover {
      background-color: var(--primary);
      transition: 0.2s ease-in;
      color: #fff;
      box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.3),
        inset 2px 2px 5px rgba(0, 0, 0, 0.3);
    }
  }

  @media (max-width: 821px) {
    height: 100%;

    h2 {
      font-size: 22px;
    }
  }
`;

const Story = styled.div`
  margin: 0 auto;
  width: 95%;

  p {
    text-align: justify;
    padding: 10px;
    word-wrap: break-word;
    font-size: 14px;
    overflow: hidden;
    //white-space: nowrap;
    text-overflow: ellipsis;
  }

  span {
    font-size: 12px;
    color: grey;
    margin-bottom: 15px;
  }
`;
